// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../images/helpSystemImages/help_system_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*.modal_width{
    .modal-dialog{
        max-width: 60%;
    }

}*/
.modal-header button {
  font-size: 32px;
}

.overflow_scroll {
  height: calc(100vh - 180px);
  overflow-y: auto;
  overflow-x: hidden;
}

.overflow_scroll_without_header {
  height: calc(100vh - 100px);
  overflow-y: auto;
  overflow-x: hidden;
}

.close_btn {
  float: right;
  font-size: 18px;
  cursor: pointer;
}

.colse_btn_zindex {
  z-index: 9999;
}

.w-80 {
  width: 80%;
}

.mt-80 {
  margin-top: 80px;
}

.w-30 {
  width: 30%;
}

.w-50 {
  width: 50%;
}

.mt-120 {
  margin-top: 120px;
}

.mt-60 {
  margin-top: 60px !important;
}

.arrow_logo::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) top left no-repeat;
  background-size: 300px 300px;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
}

.title_rotate {
  position: fixed;
  top: 115px;
  background: none;
  transform-origin: 25px 30px;
  transform: rotate(-90deg);
  letter-spacing: 5px;
  font-size: 42px;
  font-weight: normal !important;
  text-transform: uppercase;
}

.title_rotate_pos,
.title_rotate_pos {
  top: 200px !important;
}

.title_rotate_pos_PPE {
  top: 400px !important;
  letter-spacing: 3px;
  font-size: 34px;
}

.title_rotate_pos_PPA {
  top: 450px !important;
  letter-spacing: 3px;
  font-size: 28px;
}

.title_rotate_pos_RM {
  top: 430px !important;
  letter-spacing: 3px;
}

.title_rotate_pos_SN {
  top: 250px !important;
  letter-spacing: 3px;
  font-size: 34px;
}

.image_pos {
  position: relative;
  top: -10px;
}

.img_center {
  display: block;
  margin: auto;
}

.text_left_align {
  position: relative;
  right: 10%;
  top: 20%;
}

.text_right_align {
  position: relative;
  left: 10%;
  top: 10%;
}

.height310 {
  height: 335px;
}

.bg_light_yellow {
  background-color: #fef4d5;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.0509803922);
}

.image_block_pos {
  position: absolute;
  top: -25%;
  left: 0;
  right: 0;
}

.card-text {
  font-size: 12px;
}

.left_img_pos {
  position: relative;
  left: -20%;
  top: 10%;
}

.right_side_text_pos {
  position: relative;
  top: 50%;
  right: 50%;
}

.list-struture {
  margin-top: 10px !important;
  padding: 0px 5px;
}

.list-struture li {
  font-size: 14px;
  line-height: 20px !important;
  font-weight: bold;
  list-style: none;
}

.list-struture li::before {
  content: " ";
  display: inline-block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 5px 10px 5px;
  border-color: transparent transparent #A737D5 transparent;
  margin-right: 10px;
}

.display_flex_align {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.execute_phy_align {
  position: relative;
  top: -15%;
}

.execute_notes_align li {
  list-style: none;
  padding: 10px;
  border: 1px solid #fad057;
  border-radius: 25px;
  margin-top: 15px;
  font-weight: bold;
  width: 200px;
}

.text-underline {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/home/help_system/_helpsystem.scss"],"names":[],"mappings":"AAAA;;;;;EAAA;AAOI;EACI,eAAA;AAAR;;AAIA;EACI,2BAAA;EACA,gBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,2BAAA;EACA,gBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,YAAA;EACA,eAAA;EACA,eAAA;AADJ;;AAIA;EACI,aAAA;AADJ;;AAIA;EACI,UAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,UAAA;AADJ;;AAIA;EACI,UAAA;AADJ;;AAIA;EACI,iBAAA;AADJ;;AAIA;EACI,2BAAA;AADJ;;AAMI;EACI,WAAA;EACA,sEAAA;EACA,4BAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;AAHR;;AAOA;EACI,eAAA;EACA,UAAA;EACA,gBAAA;EACA,2BAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,yBAAA;AAJJ;;AAOA;;EAEI,qBAAA;AAJJ;;AAOA;EACI,qBAAA;EACA,mBAAA;EACA,eAAA;AAJJ;;AAOA;EACI,qBAAA;EACA,mBAAA;EACA,eAAA;AAJJ;;AAOA;EACI,qBAAA;EACA,mBAAA;AAJJ;;AAOA;EACI,qBAAA;EACA,mBAAA;EACA,eAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,UAAA;AAJJ;;AAOA;EACI,cAAA;EACA,YAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,UAAA;EACA,QAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;AAJJ;;AAOA;EACI,aAAA;AAJJ;;AAOA;EACI,yBAAA;EACA,oDAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AAJJ;;AAOA;EACI,eAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,UAAA;EACA,QAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,QAAA;EACA,UAAA;AAJJ;;AAOA;EACI,2BAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,eAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;AAJJ;;AASQ;EACI,YAAA;EACA,qBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,4BAAA;EACA,yDAAA;EACA,kBAAA;AANZ;;AAWA;EACI,aAAA;EACA,sBAAA;EACA,2BAAA;AARJ;;AAWA;EACI,kBAAA;EACA,SAAA;AARJ;;AAWA;EACI,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AARJ;;AAWA;EACI,0BAAA;AARJ","sourcesContent":["/*.modal_width{\n    .modal-dialog{\n        max-width: 60%;\n    }\n    \n}*/\n.modal-header {\n    button {\n        font-size: 32px;\n    }\n}\n\n.overflow_scroll {\n    height: calc(100vh - 180px);\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.overflow_scroll_without_header {\n    height: calc(100vh - 100px);\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.close_btn {\n    float: right;\n    font-size: 18px;\n    cursor: pointer;\n}\n\n.colse_btn_zindex {\n    z-index: 9999;\n}\n\n.w-80 {\n    width: 80%;\n}\n\n.mt-80 {\n    margin-top: 80px;\n}\n\n.w-30 {\n    width: 30%;\n}\n\n.w-50 {\n    width: 50%;\n}\n\n.mt-120 {\n    margin-top: 120px;\n}\n\n.mt-60 {\n    margin-top: 60px !important;\n}\n\n.arrow_logo {\n\n    &::before {\n        content: \"\";\n        background: url('../../../../images/helpSystemImages/help_system_bg.png') top left no-repeat;\n        background-size: 300px 300px;\n        position: absolute;\n        left: 0;\n        top: 0;\n        width: 100%;\n        height: 100vh;\n    }\n}\n\n.title_rotate {\n    position: fixed;\n    top: 115px;\n    background: none;\n    transform-origin: 25px 30px;\n    transform: rotate(-90deg);\n    letter-spacing: 5px;\n    font-size: 42px;\n    font-weight: normal !important;\n    text-transform: uppercase;\n}\n\n.title_rotate_pos,\n.title_rotate_pos {\n    top: 200px !important;\n}\n\n.title_rotate_pos_PPE {\n    top: 400px !important;\n    letter-spacing: 3px;\n    font-size: 34px;\n}\n\n.title_rotate_pos_PPA {\n    top: 450px !important;\n    letter-spacing: 3px;\n    font-size: 28px;\n}\n\n.title_rotate_pos_RM {\n    top: 430px !important;\n    letter-spacing: 3px;\n}\n\n.title_rotate_pos_SN {\n    top: 250px !important;\n    letter-spacing: 3px;\n    font-size: 34px;\n}\n\n.image_pos {\n    position: relative;\n    top: -10px;\n}\n\n.img_center {\n    display: block;\n    margin: auto;\n}\n\n.text_left_align {\n    position: relative;\n    right: 10%;\n    top: 20%;\n}\n\n.text_right_align {\n    position: relative;\n    left: 10%;\n    top: 10%;\n}\n\n.height310 {\n    height: 335px;\n}\n\n.bg_light_yellow {\n    background-color: #fef4d5;\n    box-shadow: 0px 3px 20px #0000000d;\n}\n\n.image_block_pos {\n    position: absolute;\n    top: -25%;\n    left: 0;\n    right: 0;\n}\n\n.card-text {\n    font-size: 12px;\n}\n\n.left_img_pos {\n    position: relative;\n    left: -20%;\n    top: 10%;\n}\n\n.right_side_text_pos {\n    position: relative;\n    top: 50%;\n    right: 50%;\n}\n\n.list-struture {\n    margin-top: 10px !important;\n    padding: 0px 5px;\n}\n\n.list-struture li {\n    font-size: 14px;\n    line-height: 20px !important;\n    font-weight: bold;\n    list-style: none;\n}\n\n.list-struture {\n    li {\n        &::before {\n            content: \" \";\n            display: inline-block;\n            width: 0;\n            height: 0;\n            border-style: solid;\n            border-width: 0 5px 10px 5px;\n            border-color: transparent transparent #A737D5 transparent;\n            margin-right: 10px;\n        }\n    }\n}\n\n.display_flex_align {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n}\n\n.execute_phy_align {\n    position: relative;\n    top: -15%;\n}\n\n.execute_notes_align li {\n    list-style: none;\n    padding: 10px;\n    border: 1px solid #fad057;\n    border-radius: 25px;\n    margin-top: 15px;\n    font-weight: bold;\n    width: 200px;\n}\n\n.text-underline {\n    text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
